import image1 from '@/main/assets/images/homepage/shutterstock_2123937818.jpg';
import image2 from '@/main/assets/images/homepage/shutterstock_2151193513.jpg';
import image3 from '@/main/assets/images/homepage/shutterstock_2473639957.jpg';
import image4 from '@/main/assets/images/homepage/shutterstock_2042952281.jpg';
import image5 from '@/main/assets/images/homepage/Supplier 1.png';
import image6 from '@/main/assets/images/homepage/line-supplier.png'

import * as S from './styles';
import TextImage from '../components/textImage/textImage';
import { getTranslateByKey } from '@/main/services/utils';

function HomepageSupplierScreen() {
  return (
    <S.Container>
      <S.FirstSection>
        <TextImage
          isWithPadding={false}
          backgroundImage={image1}
          idImage="id-homepage-supplier-image-1"
          description=""
          title={getTranslateByKey('information.homepageSupplier1')}
          positionImage="right"
          imageProps={{
            clipBorderImage: 'bottom',
            width: '410px',
            height: '532px'
          }}
          showButton={true}
          subTitle={getTranslateByKey('information.forSuppliers')}
        />
      </S.FirstSection>
      <S.ImageLine src={image6} />
      <TextImage
        backgroundImage={image2}
        idImage="id-homepage-supplier-image-2"
        title={getTranslateByKey('information.homepageSupplier2')}
        description={getTranslateByKey('information.homepageSupplier3')}
        positionImage="left"
        imageProps={{
          clipBorderImage: 'bottom',
          width: '440px',
          height: '430px'
        }}
      />
      <TextImage
        backgroundImage={image3}
        idImage="id-homepage-supplier-image-3"
        title={getTranslateByKey('information.homepageSupplier4')}
        description={getTranslateByKey('information.homepageSupplier5')}
        positionImage="right"
        imageProps={{
          clipBorderImage: 'bottom',
          width: '440px',
          height: '430px'
        }}
      />
      <TextImage
        backgroundImage={image4}
        idImage="id-homepage-supplier-image-4"
        title={getTranslateByKey('information.homepageSupplier6')}
        description={getTranslateByKey('information.homepageSupplier7')}
        positionImage="left"
        imageProps={{
          clipBorderImage: 'right',
          width: '530px',
          height: '340px'
        }}
      />
      <TextImage
        backgroundImage={image5}
        idImage="id-homepage-supplier-image-5"
        title={getTranslateByKey('information.homepageSupplier8')}
        description={getTranslateByKey('information.homepageSupplier9')}
        positionImage="right"
        imageProps={{
          clipBorderImage: 'bottom',
          width: '450px',
          height: '480px'
        }}
      />
    </S.Container>
  );
}

export default HomepageSupplierScreen;
